import $ from 'jquery';
import { kill } from './utilities';
/**
 *
 * @module podcasts-module
 * @version 1.0.0
 * @author hello@bradenericson.com
 *
 */

class PodcastsModule {

  constructor(element) {
    this.$el = $(element);
    this.$podcastLinks = this.$el.find('.podcast-link');
    this.setBinds();
    //this.adjustContainerHeight();
  }

  setBinds() {
    // Bind click events for podcast links
    this.$podcastLinks.on('click', (event) => {
      //event.preventDefault();
      kill(event);
      const $link = $(event.currentTarget);
      const targetId = $link.data('target');
      const $playerToShow = $('#' + targetId);

      // Slide up any currently displayed player
      const $currentlyActive = $('.podcast-player.active');
      if ($currentlyActive.length && !$currentlyActive.is($playerToShow)) {
        $currentlyActive.slideUp().removeClass('active');
        this.stopPlayer($currentlyActive);
      }

      // Slide down or up the new player based on its current state
      if (!$playerToShow.hasClass('active')) {
        $playerToShow.slideDown().addClass('active');
      } else {
        this.stopPlayer($playerToShow);
        $playerToShow.slideUp().removeClass('active');
      }
    });
  }
  adjustContainerHeight() {
    var totalHeight = 0;
    this.$podcastLinks.each(function() {
      totalHeight += $(this).outerHeight(true); // true includes margin
    });
  
    // Assuming fixed height for the player
    var playerHeight = $('.podcast-player').outerHeight(true) || 0;
    var newHeight = totalHeight + playerHeight;
  
    this.$el.height(newHeight);
  }
  stopPlayer($player) {
    // Stop an audio element if it exists
    const $audio = $player.find('audio');
    if ($audio.length) {
      $audio[0].pause();
    }
  
    // Reset iframe src to stop playback
    const $iframe = $player.find('iframe');
    if ($iframe.length) {
      $iframe.attr('src', $iframe.attr('src'));
    }
  }
}

export default PodcastsModule;